import RestApiClient from './RestApiClient';

const trackApiCall = (idCompetition, parameters, successCallback, catchCallback) => {

    RestApiClient({
        apiV2: true,
        relativeUrl: `/event/${idCompetition}`,
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const optinApi = (parameters, token, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/optin',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters,
        authenticated: true,
        token: token
    });
}

const optinSocialApi = (parameters, token, successCallback, catchCallback) => {

    RestApiClient({
        apiV2: true,
        relativeUrl: `/terms`,
        type: 'PUT',
        successCallback,
        catchCallback,
        payload: parameters,
        authenticated: true,
        token: token
    });
}

const loginFace = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/facelogin',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const retrieveTwitterAccessToken = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/twitter/login',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}


const retrieveTwitterToken = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: `/twitter/requesttoken/${parameters.idCompetition}`,
        type: 'GET',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const login = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/login',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const logoff = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/login', // TODO: replace by token invalidation endpoint
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const register = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/registerlogin',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const forgotCall = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/recover',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const resetCall = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/reset',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const emailConfirmation = (parameters, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/confirmation',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

const getActiveCompetitions = (hash, successCallback, catchCallback) => {

    RestApiClient({
        apiV2: true,
        relativeUrl: `/competition/hash/${hash}`,
        type: 'GET',
        successCallback,
        catchCallback
    });
}

const getAwsTokens = (successCallback, catchCallback) => {

    RestApiClient({
        apiV2: true,
        relativeUrl: `/competition/hash`,
        type: 'GET',
        successCallback,
        catchCallback
    });
}

const getLeaderboardsApi = (successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/leaderboards',
        type: 'GET',
        successCallback,
        catchCallback
    });
}

const submit = (parameters, token, successCallback, catchCallback) => {

    RestApiClient({
        relativeUrl: '/vote/leaderboard',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters,
        authenticated: true,
        token: token
    });
}

const submitImage = (parameters, successCallback, catchCallback) => {
    RestApiClient({
        apiV2: true,
        relativeUrl: '/lead-form/create',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters,
        authenticated: true
    });
}

const reValidateToken = (parameters, successCallback, catchCallback) => {
    RestApiClient({
        relativeUrl: '/revalidate',
        type: 'POST',
        successCallback,
        catchCallback,
        payload: parameters
    });
}

export {
    login, loginFace, retrieveTwitterToken,
    retrieveTwitterAccessToken,
    logoff, register, emailConfirmation,
    getActiveCompetitions, submit, getLeaderboardsApi,
    reValidateToken, forgotCall, resetCall, optinApi,
    optinSocialApi,
    trackApiCall,
    getAwsTokens,
    submitImage
}



// WEBPACK FOOTER //
// ./src/util/api_calls/PhotowallApiCalls.js